<template>
  <div class="your-page">
      <div class="section">
          <div class="container">
              <ins class="adsbygoogle"
                   style="display:block"
                   data-ad-client="ca-pub-9081865004858391"
                   data-ad-slot="8481329516"
                   data-ad-format="auto"
                   data-full-width-responsive="true"></ins>
          </div>
      </div>
  </div>
</template>

  
<script>
export default {
    name: 'Ads',
    mounted() {
      this.adsenseAddLoad();
    },
    methods:{
      adsenseAddLoad(){
          let inlineScript   = document.createElement("script");
          inlineScript.type  = "text/javascript";
          inlineScript.text  = '(adsbygoogle = window.adsbygoogle || []).push({});'
          document.getElementsByTagName('body')[0].appendChild(inlineScript);
      }
    }
}
</script>